module.exports = __webpack_public_path__ + "media/images/ofp-b41a9e6ed25ed420dff03303604fa4a7.png";